import { render, staticRenderFns } from "./LanguagesComp.vue?vue&type=template&id=30b3f24c"
import script from "./LanguagesComp.vue?vue&type=script&lang=js"
export * from "./LanguagesComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports